/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import cx from "classnames";
import axios from "axios";
import TagManager from "react-gtm-module";
import { withRouter } from "react-router-dom";

import classes from "./Checkout.module.scss";
import FormTitle from "../../../../components/FormTitle/FormTitle";
import * as ROUTES from "../../../../constants/routes";
import FormController from "../../../../components/FormController/FormController";
import CheckoutForm from "./CheckoutForm/CheckoutForm";
import PersonalForm from "./PersonalForm/PersonalForm";
import moment from "moment";
import { format } from "date-fns-tz";

import checkIcon from "../../../../assets/images/check.png";
// import CheckoutModal from "./CheckoutModal/CheckoutModal";
// import CheckoutModalSchedule from "./CheckoutModal/CheckoutModalSchedule";
import ReactGA from "react-ga";
import Rollbar from "rollbar";
import { API_URL } from "../../../../config";
import { adobeProductTracking } from "../../../../helpers/tracking";

class Checkout extends Component {
  state = {
    loading: false,
    error: false,
    checkoutResult: "",
    cardInfoResult: "",
    personalInforResult: {},
    totalInfo: "",
    cartId: "",
    clientToken: "",
    validation: true,
    validationErrorMsg: "",
    checkoutSuccess: false,
    loaderShow: false,
    checkoutModalToggle: false,
    checkoutModalScheduleToggle: false,
    selectedPaymentPlan: {
      index: 0,
    },
    numOfTickets: null,
    rollbar: new Rollbar({
      accessToken: "0b54eebaa41c4349a528260a86c385f4",
      captureUncaught: false,
      captureUnhandledRejections: false,
    }),
    trackingProduct: null,
  };
  componentDidMount() {
    console.log("this.props.groupGameSelected", this.props.groupGameSelected);
    if (!this.props.groupGameSelected) {
      this.props.history.push("/");
      return;
    }

    const { opponent, date } = this.props.groupGameSelected;
    const products = `Washington Nationals;${
      opponent?.name
    } at Nationals-${format(new Date(date), "MM/dd/yyyy")} ${format(
      new Date(date),
      "HH:mm"
    )};${this.props.selectedSeatsNodes.length}`;

    this.setState({
      loaderShow: true,
    });
    this.setState({
      trackingProducts: products,
    });

    if (
      !this.props?.groupGameSelected?.eventId ||
      !this.props.selectedMainSection
    ) {
      this.props.history.push("/");
    } else {
      adobeProductTracking({
        pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: Group Tickets: Ticket Single Group Checkout`,
        products,
      });
    }

    ReactGA.pageview("/ticket-single-group/ticket-single-group-checkout");

    let ticketQuantity = null;
    let ticketIds = [];
    if (this.props.selectedSeatsNodes?.length > 0) {
      this.props.selectedSeatsNodes.forEach((seat) => {
        const [section, row, seatNumber] = seat.split("-");
        const _seat = this.props.sectionsAvailableSeats[section].find(
          (s) => s.row === row && s.seatNumber === seatNumber
        );
        ticketIds.push(_seat);
      });
      // console.log("ticketIds", ticketIds);
    }
    ticketQuantity = this.props.selectedSeatsNodes.length;

    // console.log({
    //   q: ticketQuantity,
    //   eventId: this.props.groupGameSelected.eventId,
    //   auid: this.props.selectedMainSection.auid,
    //   bid: "41319",
    //   tids: ticketIds.map((x) => x.id), // Ticket ids from getEventSeatAvailability
    //   sid: this.props.selectedMainSection.section, // mainSection selected ID,
    //   psid: this.props.selectedMainSection["ps-key"], // ps-key mainSection selected ID
    // });
    // if (!true) {
    axios
      .post(`${API_URL}${"/createEventTicketsCart"}`, {
        q: ticketQuantity,
        eventId: this.props.groupGameSelected.eventId,
        auid: this.props.selectedMainSection.auid,
        bid: "41319",
        tids: ticketIds.map((x) => x.id), // Ticket ids from getEventSeatAvailability
        sid: this.props.selectedMainSection.section, // mainSection selected ID,
        // psid: this.props.selectedMainSection["ps-key"], // ps-key mainSection selected ID
      })
      .then((response) => {
        this.setState({
          totalInfo: response.data.info.costs,
          seatLocation: response.data.info.location,
          etag: response.data.info["patrons-create-etag"],
          paymentPlanOptions: response.data.info.costs.plans,
          selectedPaymentPlan: {
            ...this.state.selectedPaymentPlan,
            planPrice: response.data.info.costs.total,
            dueLater: response.data.info.costs.plans[0].dueLater,
            installments: response.data.info.costs.plans[1]
              ? response.data.info.costs.plans[1].installments
              : null,
            paymentType: "payinfull",
          },
          clientToken:
            response.data.info["braintree-request-result"]["braintreeToken"][
              "clientToken"
            ],
          cartId: response.data.info.cart,
          loaderShow: false,
        });
        return response.data.info.location;
      })
      .catch((error) => {
        this.setState({ error: true, loaderShow: false });
      });
    // }
    this.createplans();
  }
  componentWillUnmount() {
    if (this.state.cartId) {
      axios
        .post(`${API_URL}/deleteCart`, {
          cart: this.state["cartId"],
        })
        .then((response) => {})
        .catch((error) => {
          this.setState({ error: true });
        });
    }
  }

  getState = (zipcode) => {
    //let thisst = '';
    let thisstate = "";
    // Ensure param is a string to prevent unpredictable parsing results
    if (typeof zipcode !== "string") {
      console.log("Must pass the zipcode as a string.");
      return;
    }
    // Ensure you don't parse codes that start with 0 as octal values
    const thiszip = parseInt(zipcode, 10);
    // Code blocks alphabetized by state
    if (thiszip >= 35000 && thiszip <= 36999) {
      //thisst = 'AL';
      thisstate = "Alabama";
    } else if (thiszip >= 99500 && thiszip <= 99999) {
      //thisst = 'AK';
      thisstate = "Alaska";
    } else if (thiszip >= 85000 && thiszip <= 86999) {
      //thisst = 'AZ';
      thisstate = "Arizona";
    } else if (thiszip >= 71600 && thiszip <= 72999) {
      //thisst = 'AR';
      thisstate = "Arkansas";
    } else if (thiszip >= 90000 && thiszip <= 96699) {
      //thisst = 'CA';
      thisstate = "California";
    } else if (thiszip >= 80000 && thiszip <= 81999) {
      //thisst = 'CO';
      thisstate = "Colorado";
    } else if (thiszip >= 6000 && thiszip <= 6999) {
      //thisst = 'CT';
      thisstate = "Connecticut";
    } else if (thiszip >= 19700 && thiszip <= 19999) {
      //thisst = 'DE';
      thisstate = "Delaware";
    } else if (thiszip >= 32000 && thiszip <= 34999) {
      //thisst = 'FL';
      thisstate = "Florida";
    } else if (thiszip >= 30000 && thiszip <= 31999) {
      //thisst = 'GA';
      thisstate = "Georgia";
    } else if (thiszip >= 96700 && thiszip <= 96999) {
      //thisst = 'HI';
      thisstate = "Hawaii";
    } else if (thiszip >= 83200 && thiszip <= 83999) {
      //thisst = 'ID';
      thisstate = "Idaho";
    } else if (thiszip >= 60000 && thiszip <= 62999) {
      //thisst = 'IL';
      thisstate = "Illinois";
    } else if (thiszip >= 46000 && thiszip <= 47999) {
      //thisst = 'IN';
      thisstate = "Indiana";
    } else if (thiszip >= 50000 && thiszip <= 52999) {
      //thisst = 'IA';
      thisstate = "Iowa";
    } else if (thiszip >= 66000 && thiszip <= 67999) {
      //thisst = 'KS';
      thisstate = "Kansas";
    } else if (thiszip >= 40000 && thiszip <= 42999) {
      //thisst = 'KY';
      thisstate = "Kentucky";
    } else if (thiszip >= 70000 && thiszip <= 71599) {
      //thisst = 'LA';
      thisstate = "Louisiana";
    } else if (thiszip >= 3900 && thiszip <= 4999) {
      //thisst = 'ME';
      thisstate = "Maine";
    } else if (thiszip >= 20600 && thiszip <= 21999) {
      //thisst = 'MD';
      thisstate = "Maryland";
    } else if (thiszip >= 1000 && thiszip <= 2799) {
      //thisst = 'MA';
      thisstate = "Massachusetts";
    } else if (thiszip >= 48000 && thiszip <= 49999) {
      //thisst = 'MI';
      thisstate = "Michigan";
    } else if (thiszip >= 55000 && thiszip <= 56999) {
      //thisst = 'MN';
      thisstate = "Minnesota";
    } else if (thiszip >= 38600 && thiszip <= 39999) {
      //thisst = 'MS';
      thisstate = "Mississippi";
    } else if (thiszip >= 63000 && thiszip <= 65999) {
      //thisst = 'MO';
      thisstate = "Missouri";
    } else if (thiszip >= 59000 && thiszip <= 59999) {
      //thisst = 'MT';
      thisstate = "Montana";
    } else if (thiszip >= 27000 && thiszip <= 28999) {
      //thisst = 'NC';
      thisstate = "North Carolina";
    } else if (thiszip >= 58000 && thiszip <= 58999) {
      //thisst = 'ND';
      thisstate = "North Dakota";
    } else if (thiszip >= 68000 && thiszip <= 69999) {
      //thisst = 'NE';
      thisstate = "Nebraska";
    } else if (thiszip >= 88900 && thiszip <= 89999) {
      //thisst = 'NV';
      thisstate = "Nevada";
    } else if (thiszip >= 3000 && thiszip <= 3899) {
      //thisst = 'NH';
      thisstate = "New Hampshire";
    } else if (thiszip >= 7000 && thiszip <= 8999) {
      //thisst = 'NJ';
      thisstate = "New Jersey";
    } else if (thiszip >= 87000 && thiszip <= 88499) {
      //thisst = 'NM';
      thisstate = "New Mexico";
    } else if (thiszip >= 10000 && thiszip <= 14999) {
      //thisst = 'NY';
      thisstate = "New York";
    } else if (thiszip >= 43000 && thiszip <= 45999) {
      //thisst = 'OH';
      thisstate = "Ohio";
    } else if (thiszip >= 73000 && thiszip <= 74999) {
      //thisst = 'OK';
      thisstate = "Oklahoma";
    } else if (thiszip >= 97000 && thiszip <= 97999) {
      //thisst = 'OR';
      thisstate = "Oregon";
    } else if (thiszip >= 15000 && thiszip <= 19699) {
      //thisst = 'PA';
      thisstate = "Pennsylvania";
    } else if (thiszip >= 300 && thiszip <= 999) {
      //thisst = 'PR';
      thisstate = "Puerto Rico";
    } else if (thiszip >= 2800 && thiszip <= 2999) {
      //thisst = 'RI';
      thisstate = "Rhode Island";
    } else if (thiszip >= 29000 && thiszip <= 29999) {
      //thisst = 'SC';
      thisstate = "South Carolina";
    } else if (thiszip >= 57000 && thiszip <= 57999) {
      //thisst = 'SD';
      thisstate = "South Dakota";
    } else if (thiszip >= 37000 && thiszip <= 38599) {
      //thisst = 'TN';
      thisstate = "Tennessee";
    } else if (
      (thiszip >= 75000 && thiszip <= 79999) ||
      (thiszip >= 88500 && thiszip <= 88599)
    ) {
      //thisst = 'TX';
      thisstate = "Texas";
    } else if (thiszip >= 84000 && thiszip <= 84999) {
      //thisst = 'UT';
      thisstate = "Utah";
    } else if (thiszip >= 5000 && thiszip <= 5999) {
      //thisst = 'VT';
      thisstate = "Vermont";
    } else if (thiszip >= 22000 && thiszip <= 24699) {
      //thisst = 'VA';
      thisstate = "Virginia";
    } else if (thiszip >= 20000 && thiszip <= 20599) {
      //thisst = 'DC';
      thisstate = "Washington DC";
    } else if (thiszip >= 98000 && thiszip <= 99499) {
      //thisst = 'WA';
      thisstate = "Washington";
    } else if (thiszip >= 24700 && thiszip <= 26999) {
      //thisst = 'WV';
      thisstate = "West Virginia";
    } else if (thiszip >= 53000 && thiszip <= 54999) {
      //thisst = 'WI';
      thisstate = "Wisconsin";
    } else if (thiszip >= 82000 && thiszip <= 83199) {
      //thisst = 'WY';
      thisstate = "Wyoming";
    } else {
      //thisst = 'none';
      thisstate = "none";
    }
    return thisstate;
  };
  onClickCheckoutSubmit = (title, checkoutInfo) => {
    if (this.isEmpty(this.state.personalInforResult.firstName)) {
      console.log("1");
      this.setState({
        validationErrorMsg: "First Name is required",
        validation: false,
      });
      return;
    }
    if (this.isEmpty(this.state.personalInforResult.lastName)) {
      console.log("2");
      this.setState({
        validationErrorMsg: "Last Name is required",
        validation: false,
      });
      return;
    }
    if (!this.isEmail(this.state.personalInforResult.email)) {
      console.log("3");
      this.setState({
        validationErrorMsg: "Invalid Email",
        validation: false,
      });
      return;
    }
    if (this.isEmpty(this.state.personalInforResult.address)) {
      console.log("4");
      this.setState({
        validationErrorMsg: "Address is required",
        validation: false,
      });
      return;
    }

    if (this.isEmpty(this.state.personalInforResult.phone)) {
      console.log("4-4");
      this.setState({
        validationErrorMsg: "Phone is required",
        validation: false,
      });
      return;
    }
    if (this.isEmpty(this.state.personalInforResult.zip)) {
      console.log("5");
      this.setState({
        validationErrorMsg: "Zip Code is required",
        validation: false,
      });
      return;
    }
    if (this.isEmpty(this.state.personalInforResult.state)) {
      console.log("51");
      this.setState({
        validationErrorMsg: "State is required",
        validation: false,
      });
      return;
    }
    if (this.getState(this.state.personalInforResult.zip) === "none") {
      console.log("6");
      this.setState({
        validationErrorMsg: "Zip Code is not valid",
        validation: false,
      });
      return;
    }

    if (
      checkoutInfo === null ||
      checkoutInfo === "undefined" ||
      title === "Error"
    ) {
      console.log("7");
      this.setState({
        validationErrorMsg: "Invalid Card Information",
        validation: false,
      });
      return;
    }

    // if (
    //   this.props["seatInfoSelected"] === "" ||
    //   typeof this.props.seatInfoSelected == "undefined" ||
    //   this.props.seatInfoSelected === null
    // ) {
    //   console.log("8");
    //   this.setState({
    //     validationErrorMsg:
    //       "Sorry! There is an error. Please click the “Chat with Representative” button below or e-mail us at TicketInfo@Nationals.com to finalize your order.",
    //     validation: false,
    //   });
    //   return;
    // }
    this.setState({
      validationErrorMsg: "",
      validation: true,
      cardInfoResult: checkoutInfo,
      loaderShow: true,
    });

    const gameInfoStr = `Washington Nationals vs. ${
      this.props.groupGameSelected.opponent.name
    }, ${format(new Date(this.props.groupGameSelected.date), "EEEE")} ${format(
      new Date(this.props.groupGameSelected.date),
      "MMMM"
    )} ${format(new Date(this.props.groupGameSelected.date), "d")} @ ${format(
      new Date(this.props.groupGameSelected.date),
      "p"
    )}`;

    axios
      .post(`${API_URL}/checkoutCart`, {
        price: this.state.selectedPaymentPlan.planPrice,
        paymentType: this.state.selectedPaymentPlan.paymentType,
        dueLater: this.state.selectedPaymentPlan.dueLater,
        service: this.state.totalInfo.serviceCharges,
        cart: this.state.cartId,
        uuid: "sECyws4gDk",
        auid: this.props.selectedMainSection.auid,
        sid: this.props.selectedMainSection.section,
        location: this.state.seatLocation,
        "nonce-id": checkoutInfo.nonce,
        "card-identity": checkoutInfo.details,
        email: this.state.personalInforResult.email,
        last: this.state.personalInforResult.lastName,
        first: this.state.personalInforResult.firstName,
        phone: this.state.personalInforResult.phone,
        address: this.state.personalInforResult.address,
        city: this.state.personalInforResult.city,
        state: this.state.personalInforResult.state,
        zip: this.state.personalInforResult.zip,
        etag: this.state.etag.replace(/['/"]+/g, ""),
        selectedArea: this.props.selectedMainSection.name,
        gameInfo: gameInfoStr,
      })
      .then((response) => {
        setTimeout(() => {
          if (
            !response.data.info ||
            !response.data.info.orderId ||
            response.data.info.orderId === ""
          ) {
            console.log("error", response.data.message);
            this.state.rollbar.info(
              "Checkout Cart Error (data.info, data.info.orderId)",
              response.data
            );
            this.setState({
              validationErrorMsg: `Sorry! There is an error. Please click the “Chat with Representative” button below or e-mail us at TicketInfo@Nationals.com to finalize your order.`,
              loaderShow: false,
              validation: false,
            });
          } else if (response.data.status !== "error") {
            this.setState({
              checkoutSuccess: true,
              loaderShow: false,
              validation: true,
              validationErrorMsg: "",
              cartId: null,
            });

            const tagManagerArgs = {
              dataLayer: {
                event: "tixfinder_confirmation",
                Quantity: this.props.selectedSeatsNodes.length,
                Revenue: this.state.totalInfo.total.toLocaleString("en-US"),
                gameInfo: gameInfoStr,
                facevalue:
                  this.state.totalInfo.subTotal.toLocaleString("en-US"),
                dateofpur: Date(Date.now().toString()),
                billingstate: this.state.personalInforResult.state,
                billingzip: this.state.personalInforResult.zip,
                orderID: response.data.info ? response.data.info.orderId : "",
              },
              dataLayerName: "dataLayer",
            };

            TagManager.dataLayer(tagManagerArgs);
            if (window.adobeAnalytics) {
              adobeProductTracking({
                pageName:
                  "Washington Nationals: Tickets: Nationals Ticketfinder: Group Tickets: Ticket Single Group Confirmation",
                products: `${
                  this.state.trackingProducts
                };${this.state.totalInfo.total.toLocaleString("en-US")}`,
                events: "purchase",
              });
            }
          } else {
            console.log("error", response);
            this.state.rollbar.info(
              "Checkout Cart Error (response.data.status !== error)",
              response.data
            );
            this.setState({
              validationErrorMsg: `Sorry! There is an error. Please click the “Chat with Representative” button below or e-mail us at TicketInfo@Nationals.com to finalize your order, ${response.data.message} .`,
              loaderShow: false,
              validation: false,
            });
          }
        }, 2000);
      })
      .catch((error) => {
        console.log("error", error);
        this.state.rollbar.info(
          "Checkout Cart Error (promise catch error)",
          error
        );
        this.setState({
          validationErrorMsg: `Sorry! There is an error. Please click the “Chat with Representative” button below or e-mail us at TicketInfo@Nationals.com to finalize your order.`,
          loaderShow: false,
          validation: false,
        });
      });
  };

  onChangePersonalForm = (result) => {
    this.setState({
      personalInforResult: result,
    });
  };
  onClickCheckoutModalToggle = () => {
    this.setState({
      checkoutModalToggle: !this.state.checkoutModalToggle,
    });
  };
  onClickCheckoutModalScheduleToggle = () => {
    this.setState({
      checkoutModalScheduleToggle: !this.state.checkoutModalScheduleToggle,
    });
  };

  onChangePaymentPlan = (value) => {
    this.setState({
      selectedPaymentPlan: {
        ...this.state.selectedPaymentPlan,
        planId: value.id,
        paymentType:
          this.state.totalInfo.total === value.due ? "payinfull" : value.id,
        planPrice: value.due,
        dueLater: value.dueLater,
        index: value.index,
      },
    });
  };

  // validations
  isEmail = (email) => {
    // eslint-disable-next-line no-useless-escape
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  };
  isEmpty = (value) => {
    return typeof value === "undefined" || value === "";
  };

  numberFormat = (number, decimals, dec_point, thousands_sep) => {
    // Strip all characters but numerical ones.
    number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
      dec = typeof dec_point === "undefined" ? "." : dec_point,
      s = "",
      toFixedFix = function (n, prec) {
        var k = Math.pow(10, prec);
        return "" + Math.round(n * k) / k;
      };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
  };
  async createplans() {
    if (this.props.cms) {
      let _planSchedules = {};
      // let _scheduleSelectionValues = {};

      const cms = this.props.cms;

      await cms.forEach(async (style, index) => {
        await style.plans.forEach((plan) => {
          plan.schedules.forEach((schedule) => {
            _planSchedules[schedule.UUID] = {
              parkingLink: schedule.parkingUrl,
              planTitle: plan.name,
              planDesc: schedule.desc,
              planSubTitle: schedule.name,
              flexMultiply: schedule.flexMultiply || 1,
              games: schedule?.games?.map(({ info }) => info),
            };
          });
        });
      });
      this.setState({
        planSchedules: _planSchedules,
      });
    }
  }
  render() {
    // console.log("this.state.totalInfo", this.state.totalInfo);
    // if (!this.state.totalInfo) {
    //   return <p>Loading ...</p>;
    // }

    return (
      <>
        <FormTitle title="Checkout" />
        {this.state.checkoutSuccess ? (
          <div className={classes.Checkout}>
            <div className={classes.Checkout__success}>
              <h3>
                <img src={checkIcon} alt="" />
                Success!
              </h3>
              <h4>
                Thank you for your purchase. You will receive an e-mail with
                your receipt and other important information. Please be sure to
                check your Spam or Junk folder if you do not see the
                confirmation e-mail in your inbox.
              </h4>
            </div>
          </div>
        ) : (
          <div className={classes.Checkout_2}>
            {this.state.totalInfo && this.props.selectedMainSection ? (
              <>
                <div className={classes.Checkout}>
                  <div className={classes.orderSummary}>
                    <div className={classes.orderSummaryTitle}>Your Order</div>
                    <div className={classes.orderSummaryPlan}>
                      <span className={classes.labelName}>
                        Washington Nationals vs.
                        <br />
                        {this.props.groupGameSelected.opponent.name}
                        <br />
                        <div className={classes.date}>
                          <span>
                            {format(
                              new Date(this.props.groupGameSelected.date),
                              "EEEE"
                            )}
                          </span>
                          {", "}
                          <span>
                            {format(
                              new Date(this.props.groupGameSelected.date),
                              "MMMM"
                            )}
                          </span>{" "}
                          <span className={classes.date__day}>
                            {format(
                              new Date(this.props.groupGameSelected.date),
                              "d"
                            )}
                          </span>{" "}
                          <br />
                          <span className={classes.date__day}>
                            {format(
                              new Date(this.props.groupGameSelected.date),
                              "p"
                            )}
                          </span>
                        </div>
                        <br />
                      </span>
                      <span>
                        ${this.props.selectedMainSection.pricesFrom["41319"]}
                        <br />
                        per Ticket
                      </span>
                    </div>
                    <div className={classes.orderSummaryPlan}>
                      {this.props.selectedMainSection && (
                        <>
                          <span className={classes.labelName}>
                            Seating Location
                          </span>
                          <span>{this.props.selectedMainSection.name}</span>
                        </>
                      )}
                    </div>
                    <div className={classes.orderSummaryPlan}>
                      {this.props?.selectedSeatsNodes?.length > 0 && (
                        <>
                          <span className={classes.labelName}>
                            Ticket Quantity
                          </span>
                          <span>{this.props?.selectedSeatsNodes?.length}</span>
                        </>
                      )}
                    </div>
                    <div className={classes.orderSummaryCost}>
                      <span className={classes.labelName}>Subtotal</span>
                      <span>
                        ${this.state.totalInfo.subTotal.toLocaleString("en-US")}
                      </span>
                    </div>
                    <div className={classes.orderSummaryCost}>
                      <span className={classes.labelName}>Processing Fee</span>
                      <span>
                        $
                        {this.state.totalInfo.serviceCharges.toLocaleString(
                          "en-US"
                        )}
                      </span>
                    </div>
                    <div className={classes.orderSummaryCost}>
                      <span className={classes.labelName}>Total</span>
                      <span>
                        ${this.state.totalInfo.total.toLocaleString("en-US")}
                      </span>
                    </div>
                  </div>
                  <div className={classes.formInput}>
                    <div className={classes.formTitle}>Personal Info</div>
                    <PersonalForm
                      onChangePersonalForm={this.onChangePersonalForm}
                    />
                    <div className={classes.formTitle}>Payment Info</div>
                    <CheckoutForm
                      authorization={this.state.clientToken}
                      cartId={this.state.cartId}
                      onClickCheckoutSubmit={this.onClickCheckoutSubmit}
                      validationErrorMsg={this.state.validationErrorMsg}
                      validation={this.state.validation}
                      personalInfo={this.state.personalInforResult}
                    >
                      {this.state.paymentPlanOptions &&
                        this.state.paymentPlanOptions.length > 1 && (
                          <>
                            <div className={classes.formTitle}>
                              Payment Plans
                            </div>
                            <div className={classes.formPaymentPlan}>
                              {this.state.paymentPlanOptions.map(
                                (option, i) => {
                                  return (
                                    <label
                                      key={option.id}
                                      className={classes.formPaymentPlan__input}
                                    >
                                      <input
                                        type="radio"
                                        className={this.props.className}
                                        name="paymentPlan"
                                        checked={
                                          this.state.selectedPaymentPlan
                                            .index === i
                                            ? true
                                            : false
                                        }
                                        key={option.id}
                                        onChange={this.onChangePaymentPlan.bind(
                                          this,
                                          {
                                            ...option,
                                            index: i,
                                          }
                                        )}
                                        value={option.id}
                                      />
                                      {option.description}
                                    </label>
                                  );
                                }
                              )}
                            </div>
                            {this.state.selectedPaymentPlan.index !== 0 && (
                              <div className={classes.disclaimer__plan}>
                                <p>
                                  A separate agreement must be signed in order
                                  to finalize the purchase of certain
                                  memberships and plans. If the membership or
                                  plan you selected is one of those, a Nationals
                                  account representative will distribute an
                                  agreement to you electronically to the email
                                  address that you have provided to us and the
                                  agreement must be signed in order for you to
                                  complete your purchase. If you do not execute
                                  the agreement within the time period specified
                                  by the Nationals, the Nationals may cancel
                                  your purchase and/or require you to pay a
                                  higher price for your membership or plan.
                                </p>
                                <h3>Installment Schedule</h3>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Installments</th>
                                      <th>Due Date</th>
                                      <th>Installment Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Due Now</td>
                                      <td>
                                        $
                                        {this.numberFormat(
                                          this.state.selectedPaymentPlan
                                            .planPrice,
                                          2,
                                          ".",
                                          ","
                                        )}
                                      </td>
                                    </tr>

                                    {this.state.selectedPaymentPlan
                                      .installments &&
                                      this.state.selectedPaymentPlan.installments.map(
                                        (item, i) => (
                                          <tr key={i * 100}>
                                            <td>{i + 2}</td>
                                            <td>
                                              {moment(item["date"]).format(
                                                "LL"
                                              )}
                                            </td>
                                            <td>
                                              {item[
                                                "display-value"
                                              ].toLocaleString("en-US")}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </>
                        )}
                    </CheckoutForm>
                  </div>
                </div>
              </>
            ) : (
              <div className={classes.errorMsg}>
                {this.state.error && (
                  <p>
                    {" "}
                    Sorry! There is an error. Please click the “Chat with
                    Representative” button below or e-mail us at
                    TicketInfo@Nationals.com to finalize your order.
                  </p>
                )}
              </div>
            )}
          </div>
        )}
        <div
          className={cx(
            classes.loader__wrapper,
            this.state.loaderShow ? classes.loader__wrapper__active : ""
          )}
        >
          <div className={classes.loader}>
            <div className={classes["lds-ring"]}>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
        <FormController
          backTo="group-select-your-seats"
          nextTo=""
          startOver={ROUTES.PAGE_1_LINK}
          showBack={true}
          showStartOver={true}
          showSkip={false}
          showSubmit={false}
        />
      </>
    );
  }
}
export default withRouter(Checkout);
